
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1673_245)"}},[_c('path',{attrs:{"d":"M11.742 17.426a.5.5 0 01.516 0l4.908 2.962a.5.5 0 00.745-.542l-1.302-5.582a.5.5 0 01.16-.492l4.335-3.756a.5.5 0 00-.285-.876l-5.709-.485a.5.5 0 01-.418-.303L12.46 3.086a.5.5 0 00-.92 0L9.308 8.352a.5.5 0 01-.418.303l-5.71.485a.5.5 0 00-.284.876l4.336 3.756a.5.5 0 01.16.492l-1.303 5.582a.5.5 0 00.745.542l4.908-2.962z","fill":"#FFD440"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1673_245"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    